import { useQuery } from '@tanstack/react-query';

import { getReceipt } from '../api';

import { RQ_REPOP_PRODUCTS } from '@/modules/ReactQuery/cacheKeys';
import { useCurrentLanguage } from '@/modules/language/useCurrentLanguage';
import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { getRepopProducts } from '@/modules/sellerhub/api';

export function useRepopProducts({
  enabled,
  limit = 12,
}: {
  enabled: boolean;
  limit?: number;
}) {
  const { language } = useCurrentLanguage();
  const { location: country } = useCurrentLocation();

  const {
    data: receiptData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [RQ_REPOP_PRODUCTS, limit],
    queryFn: async () => {
      const response = await getRepopProducts({ limit });
      const products = response?.data;
      const purchaseIds = products?.map((product) => product.purchase_id);

      const result = await Promise.all(
        purchaseIds.map((purchaseId) =>
          getReceipt({ purchaseId, country, language })
        )
      );
      return result;
    },
    enabled,
  });
  const receipts = receiptData?.map((res) => res?.data).filter(Boolean) || [];

  return {
    products: receipts,
    isLoading,
    isError,
  };
}
